import * as React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { InventoryStockPointSplitItem, ItemType } from "@/gen/inventory/common_pb";
import { pharmacyClient } from "@/connect";

export default function StockPointSplitSheet({itemId, type}: {
    itemId: string;
    type: ItemType
}) {

    const [data, setData] = React.useState<InventoryStockPointSplitItem[]>([]);
    const [loading, setLoading] = React.useState(true);
    React.useEffect(() => {
        if (itemId && type) {
            pharmacyClient.inventoryStockPointSplit({
                batchId: itemId,
                itemType: type
            }).then((response) => {
                setData(response.inventoryStockPointSplitItems || []);
                setLoading(false);
            }).catch((error) => {
                console.error("Error fetching stock point split:", error);
                setLoading(false);
            });
        }
    }, [itemId, type]);

    return (
        <Sheet>
            <SheetTrigger asChild>
                <Button variant="ghost">
                    <span className="flex items-center gap-2">
                        <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
                            <rect x="2" y="2" width="5" height="5" rx="1" fill="#000"/>
                            <rect x="13" y="2" width="5" height="5" rx="1" fill="#000"/>
                            <rect x="7.5" y="13" width="5" height="5" rx="1" fill="#000"/>
                            <path d="M7 7L10 13M13 7L10 13" stroke="#000" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                    </span>
                </Button>
            </SheetTrigger>
            <SheetContent side="bottom" className="overflow-y-auto max-h-[80vh]">
                <SheetHeader>
                    <SheetTitle>Stock Point Level Split</SheetTitle>
                </SheetHeader>
                <div className="mt-4">
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead>Stock Point Name</TableHead>
                                <TableHead>Available Quantity</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {loading ? (
                                Array.from({ length: 3 }).map((_, idx) => (
                                    <TableRow key={idx}>
                                        <TableCell>
                                            <div className="h-4 bg-gray-200 rounded animate-pulse w-32" />
                                        </TableCell>
                                        <TableCell>
                                            <div className="h-4 bg-gray-200 rounded animate-pulse w-20" />
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                data.map((sp) => (
                                    <TableRow key={sp.stockPointId}>
                                        <TableCell>{sp.stockPointName}</TableCell>
                                        <TableCell>{sp.availableQuantity.toFixed(2)}</TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </div>
            </SheetContent>
        </Sheet>
    );
}